/**
 * Role-rank helpers — must mirror backend ``app/services/role_hierarchy.py``.
 *
 * The strict-less-than rule applies everywhere a caller assigns a role to
 * someone else (invite, promote, delete). Self-edits don't go through these
 * helpers — those are gated by self-protection logic in each route.
 */

import type { UserRole } from "@/api/schemas";

const RANK: Record<UserRole, number> = {
  agent: 1,
  moderator: 2,
  admin: 3,
  superadmin: 4,
};

export function roleRank(role: string | undefined | null): number {
  if (!role) return 0;
  return RANK[role as UserRole] ?? 0;
}

export function isAdminOrAbove(role: string | undefined | null): boolean {
  return roleRank(role) >= RANK.admin;
}

export function isModeratorOrAbove(role: string | undefined | null): boolean {
  return roleRank(role) >= RANK.moderator;
}

export function isSuperadmin(role: string | undefined | null): boolean {
  return role === "superadmin";
}

export function rolesBelow(callerRole: string | undefined | null): UserRole[] {
  const callerRank = roleRank(callerRole);
  return (["agent", "moderator", "admin"] as UserRole[]).filter(
    (r) => RANK[r] < callerRank,
  );
}
